import { Skeleton } from '@/components/ui/skeleton';

function LinkSkeleton() {
	return (
		<div className="hover:bg-background block px-3 py-2 rounded-md cursor-pointer">
			<Skeleton className="w-28 h-4" />
		</div>
	);
}

export default LinkSkeleton;
